module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAJ5JREFUWEfd1zEOgDAMBEH75cDLg0C0SPHdWhGkoWMHF7HIWHxycT++ARhj7NekMvN+kmdqAg9gi4iDRkwBri/uQkwDuhAlQAeiDKAREoBEyAAKYQEIhA1wEQjAQWAAFYECFMS/AMq+wCagxO8VT+x2NY4AnLgNcOMWgIjLACouAch4GUDHS4CO+DSgK14FrPsxIW7Lt3cgV7EDXA44AbbWgCHcO+lMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/right_1.png
// module id = YLW5
// module chunks = 1